export const SET_IS_LOADING = "SET_IS_LOADING";
export const SET_LAYOUT_ZOOM = "SET_LAYOUT_ZOOM";
export const INCREMENT_LAYOUT_ZOOM = "INCREMENT_LAYOUT_ZOOM";
export const DECREMENT_LAYOUT_ZOOM = "DECREMENT_LAYOUT_ZOOM";
